;(function () {
  'use strict'

  const intro = document.getElementById('intro-screen')
  if (!intro) return

  /* Safari bfcache fix: if page is restored from cache, remove intro instantly */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      var el = document.getElementById('intro-screen')
      if (el) el.remove()
    }
  })

  // Skip if navigating from within the same site (e.g. clicking HOME from another page).
  // Show on fresh visits: direct URL, bookmark, external link, or new tab.
  try {
    if (document.referrer && new URL(document.referrer).origin === window.location.origin) {
      intro.remove()
      return
    }
  } catch (e) {}

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    intro.remove()
    return
  }

  const hint = intro.querySelector('.intro-skip-hint')
  let done = false
  let blinkTimer = null
  let autoTimer = null

  function exitAnimated () {
    if (done) return
    done = true
    clearTimeout(autoTimer)
    clearTimeout(blinkTimer)

    intro.style.willChange = 'opacity, transform'
    intro.classList.add('is-exiting')

    intro.addEventListener('animationend', function onEnd () {
      intro.removeEventListener('animationend', onEnd)
      intro.style.willChange = 'auto'
      intro.remove()
    })
  }

  function exitInstant () {
    if (done) return
    done = true
    clearTimeout(autoTimer)
    clearTimeout(blinkTimer)
    intro.remove()
  }

  intro.addEventListener('click', exitInstant, { once: true })

  document.addEventListener('keydown', function onKey (e) {
    if (e.key === 'Tab') return
    document.removeEventListener('keydown', onKey)
    exitInstant()
  })

  blinkTimer = setTimeout(function () {
    if (done || !hint) return
    hint.classList.add('is-blinking')
  }, 2100)

  autoTimer = setTimeout(exitAnimated, 2500)

})()
